import { createAction } from 'redux-actions'
import Api from '../Api'

import { getAvailableColumnTypes } from '../components/functions'

export const REQUEST_STAGE_ELEMENTS = createAction('REQUEST_STAGE_ELEMENTS')
export const RECEIVE_STAGE_ELEMENTS = createAction('RECEIVE_STAGE_ELEMENTS')
export const CREATE_STAGE_ELEMENT = createAction('CREATE_STAGE_ELEMENT')
export const GET_AVAILABLE_EQUIPMENT_TYPES = createAction('GET_AVAILABLE_EQUIPMENT_TYPES')
export const REQUEST_SEARCH_RESULTS = createAction('REQUEST_SEARCH_RESULTS', (term) => ({term}))
export const RECEIVE_SEARCH_RESULTS = createAction('RECEIVE_SEARCH_RESULTS', (term, results) => ({term, results}))

export const fetchStageElements = () => {
  return (dispatch) => {
    dispatch(REQUEST_STAGE_ELEMENTS())

    dispatch(REQUEST_SEARCH_RESULTS(''))

    return dispatch(RECEIVE_STAGE_ELEMENTS(Api.getStageElements()))
  }
}

export const createStageElement = (data) => {
  return (dispatch) => dispatch(CREATE_STAGE_ELEMENT(Api.createStageElement(data)))
}

export const getAvailableEquipmentTypes = (equipmentTypes = [], columns = []) => {
  const availableColumnTypes = getAvailableColumnTypes(columns, equipmentTypes)

  return (dispatch) => dispatch(GET_AVAILABLE_EQUIPMENT_TYPES({availableColumnTypes}))
}

export const getSearchResults = (array = undefined, term = '') => {
  const searchResults = (instrument) => {
    const regexStr = '(?=.*' + term.split(/\,|\s/).join(')(?=.*') + ')'
    const searchRegEx = new RegExp(regexStr, 'gi')
    return instrument.title.toLowerCase().match(searchRegEx) !== null
  }

  return (dispatch) => {
    if (array !== undefined) {
      if (term.length >= 3) {
        dispatch(RECEIVE_SEARCH_RESULTS(term, array.filter(searchResults)))
      } else {
        dispatch(RECEIVE_SEARCH_RESULTS(term, []))
      }
    } else {
      dispatch(REQUEST_SEARCH_RESULTS(term))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/stage-elements.js